import React, { useState, useEffect } from "react";
import axios from "../../plugins/axios";
import {
    TextField,
    Autocomplete,
} from "@mui/material";

const apiUrl = process.env.REACT_APP_WORKNEST_TOOLS_API_URL;

const AccountLookup = ({ question, updateAnswer }) => {

    const [open, setOpen] = useState(false);
    const [options, setOptions] = useState([]);
    const [input, setInput] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        let active = true;

        if (!input || input.length < 3) {
            setOptions([]);
            return undefined;
        }

        (async () => {
            setLoading(true);
            const clients = (await axios.get(`${apiUrl}/getclients/` + encodeURIComponent(input))).data;
            if (active) {
                setOptions(clients);
            }
            setLoading(false);
        })();

        return () => {
            active = false;
        };
    }, [open, input]);

    return (
        <Autocomplete
            freeSolo
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            isOptionEqualToValue={(option, value) => option.value === value.value}
            getOptionLabel={(option) => option.text}
            renderOption={(props, option) => {
                const { key, ...rest } = props;
                return <li key={option.value} {...rest}>{option.text}</li>;
            }}
            onChange={(e, v) => updateAnswer(question.questionId, v && v.value)}
            options={options}
            loading={loading}
            onInputChange={(e, val, reason) => reason === "input" && setInput(val)}
            renderInput={(params) => {
                return <TextField {...params} fullWidth size="small" name="noAutoFill" />;
            }}
        />
    );
}

export default AccountLookup;
